'use strict';

/*
  Para casos de utilização de ng-bind-html, alguns elementos não são exibidos.
  $sce.trustAsHtml() compila o conteúdo para exibir corretamente.
*/

angular.module('webAgro1App').filter('trusted', function($sce) {
  return function(html) {
    return $sce.trustAsHtml(html);
  };
});
